export const MEMBER_ACCESS_FILTER_KEY_SEARCH = 'q';
export const MEMBER_ACCESS_FILTER_KEY_STATUSES = 'statuses';
export const MEMBER_ACCESS_FILTER_KEY_GROUP_IDS = 'groupIds';

export const MEMBER_ACCESS_TABLE_FILTER_KEYS = [
  MEMBER_ACCESS_FILTER_KEY_SEARCH,
  MEMBER_ACCESS_FILTER_KEY_STATUSES,
  MEMBER_ACCESS_FILTER_KEY_GROUP_IDS,
];

export const MEMBER_ACCESS_TABLE_FILTERS_STORAGE_KEY = 'member-access-table-filters';
